export const NOT_ASSIGNED_USER = {
  initials: 'NA',
  Name: 'Not Assigned',
  Companies: [{ Name: 'Unknown' }]
} as const;
